module.exports = __webpack_public_path__ + "img/P2-C5.7898f18e.svg";